import {
  addEcologyType,
  addLibrariesActivityField,
  addLibrariesDepartments,
  addLibrariesGetComponents,
  addLibrariesGroupComponents,
  addLibrariesMeasurmentUnits,
  addLibrariesObjectsParameters,
  addLibrariesOwnership,
  addLibrariesSourceParameters,
  getLibrariesGroupComponentsByEcologyTypeIngridient,
  deleteLibrariesGroupComponents,
  editComponentsInGroupComponents,
  editEcologyType,
  editLibrariesActivityField,
  editLibrariesDepartments,
  editLibrariesGetComponents,
  editLibrariesGroupComponents,
  editLibrariesMeasurmentUnits,
  editLibrariesObjectsParameters,
  editLibrariesOwnership,
  editLibrariesSourceParameters,
  fetchKENComponentsApi,
  fetchPDKComponentsApi,
  getEcologyType,
  getLibrariesActivityField,
  getLibrariesAllRegions,
  getLibrariesChildRegions,
  getLibrariesComponentsByEcologyType,
  getLibrariesDepartments,
  getLibrariesGetComponents,
  getLibrariesGetComponentsByGroup,
  getLibrariesGroupComponents,
  getLibrariesGroupComponentsByEcologyType,
  getLibrariesGroupComponentsById,
  getLibrariesMeasurmentUnits,
  getLibrariesMinistry,
  getLibrariesObjectsParameters,
  getLibrariesOwnership,
  getLibrariesParentRegions,
  getLibrariesSourceParameters,
  getLibrariesSubordination,
  updateKENComponentsApi,
  updatePDKComponentsApi,
  getAllStatisticUsers
} from "../../api/libraries";
import {
  getAllStatisticDashbord
} from "@api/emissions";

export default {
  /////////////////
  // GetComponents
  /////////////////

  fetchGetComponents({
    commit
  }, a) {
    return new Promise((resolve, reject) => {
      getLibrariesGetComponents()
        //скидывает мне по 20   принимает group_id  , если не отправить то аернет все компоненты
        .then(res => {
          // commit("SET_LIBRARIES_GET_COMPONENTS", res.data.data);
          resolve(res);
        })
        .catch(reject);
    });
  },
  fetchGetComponentsByGroup({
    commit
  }, a) {
    return new Promise((resolve, reject) => {
      getLibrariesGetComponentsByGroup(a)
        //скидывает мне по 20   принимает group_id  , если не отправить то аернет все компоненты
        .then(res => {
          // commit("SET_LIBRARIES_GET_COMPONENTS", res.data.data);
          resolve(res);
        })
        .catch(reject);
    });
  },
  addGetComponents({
    commit
  }, a) {
    return new Promise((resolve, reject) => {
      addLibrariesGetComponents(a)
        .then(res => {
          // commit("ADD_LIBRARY_GET_COMPONENTS", res.data.data);
          resolve(res);
        })
        .catch(reject);
    });
  },
  editGetComponents({
    commit
  }, a) {
    return new Promise((resolve, reject) => {
      editLibrariesGetComponents(a)
        .then(res => {
          // commit("EDIT_LIBRARIES_COMPONENTS_BY_GROUP_ID", res.data.data);
          resolve(res);
        })
        .catch(reject);
    });
  },

  /////////////////
  //MeasurmentUnits
  /////////////////

  fetchMeasurmentUnits({
    commit
  }, a) {
    return new Promise((resolve, reject) => {
      getLibrariesMeasurmentUnits(a)
        .then(res => {
          commit("SET_LIBRARIES_MEASURMENT_UNITS", res.data.data);
          resolve(res);
        })
        .catch(reject);
    });
  },
  addMeasurmentUnits({
    commit
  }, a) {
    return new Promise((resolve, reject) => {
      addLibrariesMeasurmentUnits(a)
        .then(res => {
          commit("ADD_LIBRARY_MEASURMENT_UNITS", res.data.data);
          resolve(res);
        })
        .catch(reject);
    });
  },
  fetchAllStatisticUsers({
    commit
  }, a) {
    // возвращает все виды статусов emissions
    return new Promise((resolve, reject) => {
      getAllStatisticUsers(a)
        .then(res => {
          // if (!a.excel) {
          //   commit("SET_STATISTIC_USERS", res.data.data);
          // }
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  editMeasurmentUnits({
    commit
  }, a) {
    return new Promise((resolve, reject) => {
      editLibrariesMeasurmentUnits(a)
        .then(res => {
          commit("EDIT_LIBRARY_MEASURMENT_UNITS", res.data.data);
          resolve(res);
        })
        .catch(reject);
    });
  },

  /////////////////
  // EcologyType
  /////////////////

  fetchEcologyType({
    commit
  }) {
    return new Promise((resolve, reject) => {
      getEcologyType()
        .then(res => {
          commit("SET_LIBRARY_ECOLOGY_TYPE", res.data.data);
          resolve(res);
        })
        .catch(reject);
    });
  },
  addEcologyType({
    commit
  }, a) {
    return new Promise((resolve, reject) => {
      addEcologyType(a)
        .then(res => {
          commit("ADD_LIBRARY_ECOLOGY_TYPE", res.data.data);
          resolve(res);
        })
        .catch(reject);
    });
  },
  editEcologyType({
    commit
  }, a) {
    return new Promise((resolve, reject) => {
      editEcologyType(a)
        .then(res => {
          commit("EDIT_LIBRARY_ECOLOGY_TYPE", res.data.data);
          resolve(res);
        })
        .catch(reject);
    });
  },

  /////////////////
  //Subordination
  /////////////////

  fetchSubordination({
    commit
  }, a) {
    return new Promise((resolve, reject) => {
      getLibrariesSubordination(a)
        .then(res => {
          commit("SET_LIBRARIES_SUBORDINATION", res.data.results);
          resolve(res);
        })
        .catch(reject);
    });
  },
  /////////////////
  //Ownership
  /////////////////

  fetchOwnership({
    commit
  }, a) {
    return new Promise((resolve, reject) => {
      getLibrariesOwnership(a)
        .then(res => {
          commit("SET_LIBRARIES_OWNERSHIP", res.data.data);
          resolve(res);
        })
        .catch(reject);
    });
  },
  addOwnership({
    commit
  }, a) {
    return new Promise((resolve, reject) => {
      addLibrariesOwnership(a)
        .then(res => {
          commit("ADD_LIBRARY_OWNERSHIP", res.data.data);
          resolve(res);
        })
        .catch(reject);
    });
  },
  editOwnership({
    commit
  }, a) {
    return new Promise((resolve, reject) => {
      editLibrariesOwnership(a)
        .then(res => {
          commit("EDIT_LIBRARY_OWNERSHIP", res.data.data);
          resolve(res);
        })
        .catch(reject);
    });
  },

  /////////////////
  // ActivityField
  /////////////////

  fetchActivityField({
    commit
  }, a) {
    return new Promise((resolve, reject) => {
      getLibrariesActivityField(a)
        .then(res => {
          commit("SET_LIBRARIES_ACTIVITY_FIELD", res.data.results);
          resolve(res);
        })
        .catch(reject);
    });
  },
  addActivityField({
    commit
  }, a) {
    return new Promise((resolve, reject) => {
      addLibrariesActivityField(a)
        .then(res => {
          commit("ADD_LIBRARY_ACTIVITY_FIELD", res.data.data);
          resolve(res);
        })
        .catch(reject);
    });
  },
  editActivityField({
    commit
  }, a) {
    return new Promise((resolve, reject) => {
      editLibrariesActivityField(a)
        .then(res => {
          commit("EDIT_LIBRARY_ACTIVITY_FIELD", res.data.data);
          resolve(res);
        })
        .catch(reject);
    });
  },

  /////////////////
  // Departments
  /////////////////

  fetchDepartments({
    commit
  }, a) {
    return new Promise((resolve, reject) => {
      getLibrariesDepartments(a)
        .then(res => {
          commit("SET_LIBRARIES_DEPARTMENTS", res.data.results);
          resolve(res);
        })
        .catch(reject);
    });
  },
  addDepartments({
    commit
  }, a) {
    return new Promise((resolve, reject) => {
      addLibrariesDepartments(a)
        .then(res => {
          commit("ADD_LIBRARY_DEPARTMENTS", res.data.data);
          resolve(res);
        })
        .catch(reject);
    });
  },
  editDepartments({
    commit
  }, a) {
    return new Promise((resolve, reject) => {
      editLibrariesDepartments(a)
        .then(res => {
          commit("EDIT_LIBRARY_DEPARTMENTS", res.data.data);
          resolve(res);
        })
        .catch(reject);
    });
  },

  /////////////////
  // Regions
  /////////////////
  fetchParentRegions({
    commit
  }) {
    return new Promise((resolve, reject) => {
      getLibrariesParentRegions()
        .then(res => {
          commit("SET_LIBRARIES_PARENT_REGIONS", res.data.data);
          resolve(res);
        })
        .catch(reject);
    });
  },
  fetchChildRegions({
    commit
  }, a) {
    return new Promise((resolve, reject) => {
      getLibrariesChildRegions(a)
        .then(res => {
          commit("SET_LIBRARIES_CHILD_REGIONS", res.data.data);
          resolve(res);
        })
        .catch(reject);
    });
  },
  fetchAllRegions({
    commit
  }) {
    return new Promise((resolve, reject) => {
      getLibrariesAllRegions()
        .then(res => {
          commit("SET_LIBRARIES_ALL_REGIONS", res.data.data);
          resolve(res);
        })
        .catch(reject);
    });
  },

  /////////////////
  //SourceParameters
  /////////////////
  fetchSourceParameters({
    commit
  }) {
    return new Promise((resolve, reject) => {
      getLibrariesSourceParameters()
        .then(res => {
          commit("SET_LIBRARIES_SOURCE_PARAMETERS", res.data.data);
          resolve(res);
        })
        .catch(reject);
    });
  },
  addSourceParameters({
    commit
  }, a) {
    return new Promise((resolve, reject) => {
      addLibrariesSourceParameters(a)
        .then(res => {
          commit("ADD_LIBRARY_SOURCE_PARAMETERS", res.data.data);
          resolve(res);
        })
        .catch(reject);
    });
  },
  editSourceParameters({
    commit
  }, a) {
    return new Promise((resolve, reject) => {
      editLibrariesSourceParameters(a)
        .then(res => {
          commit("EDIT_LIBRARY_SOURCE_PARAMETERS", res.data.data);
          resolve(res);
        })
        .catch(reject);
    });
  },

  /////////////////
  //ObjectsParameters
  /////////////////

  fetchObjectsParameters({
    commit
  }) {
    return new Promise((resolve, reject) => {
      getLibrariesObjectsParameters()
        .then(res => {
          commit("SET_LIBRARIES_OBJECTS_PARAMETERS", res.data.data);
          resolve(res);
        })
        .catch(reject);
    });
  },
  addObjectsParameters({
    commit
  }, a) {
    return new Promise((resolve, reject) => {
      addLibrariesObjectsParameters(a)
        .then(res => {
          commit("ADD_LIBRARY_OBJECTS_PARAMETERS", res.data.data);
          resolve(res);
        })
        .catch(reject);
    });
  },
  editObjectsParameters({
    commit
  }, a) {
    return new Promise((resolve, reject) => {
      editLibrariesObjectsParameters(a)
        .then(res => {
          commit("EDIT_LIBRARY_OBJECTS_PARAMETERS", res.data.data);
          resolve(res);
        })
        .catch(reject);
    });
  },
  /////////////////
  // Ministry getLibrariesMinistry
  /////////////////

  fetchMinistry({
    commit
  }) {
    return new Promise((resolve, reject) => {
      getLibrariesMinistry()
        .then(res => {
          commit("SET_LIBRARIES_MINISTRY", res.data.data);
          resolve(res);
        })
        .catch(reject);
    });
  },

  /////////////////
  //Group components
  /////////////////

  fetchAllGroupComponents({
    commit
  }) {
    return new Promise((resolve, reject) => {
      getLibrariesGroupComponents() // Получаю все компоненты из группы по ID группы
        .then(res => {
          commit("SET_LIBRARIES_GROUP_COMPONENTS", res.data.data);
          resolve(res);
        })
        .catch(reject);
    });
  },

  fetchGroupComponentsById({
    commit
  }, a) {
    return new Promise((resolve, reject) => {
      getLibrariesGroupComponentsById(a)
        .then(res => {
          //передаю id группы и ответ с бэка для мутации
          commit("SET_LIBRARIES_COMPONENTS_BY_GROUP_ID", {
            group_id: a.group_id,
            data: res.data.data
          });
          // commit("SET_LIBRARIES_GROUP_COMPONENTS", res.data.data);
          resolve(res);
        })
        .catch(reject);
    });
  },
  fetchGroupsComponentsByEcologyTypeIngridient({
    commit
  }, a) {
    return new Promise((resolve, reject) => {
      getLibrariesGroupComponentsByEcologyTypeIngridient(a)

        .then(res => {
          resolve(res);
        })
        .catch(reject);
    });
  },
  fetchGroupsComponentsByEcologyType({
    commit
  }, a) {
    return new Promise((resolve, reject) => {
      getLibrariesGroupComponentsByEcologyType(a)
        /*
          ecology_type_id: int  required
          ** group_id: int
          ** in_group : Boolean
        */
        .then(res => {
          // commit("SET_LIBRARIES_GROUP_COMPONENTS", res.data.data);
          resolve(res);
        })
        .catch(reject);
    });
  },
  fetchComponentsByEcologyType({
    commit
  }, a) {
    return new Promise((resolve, reject) => {
      getLibrariesComponentsByEcologyType(a)
        /*
          ecology_type_id: int  required
          group_id: int
          in_group : Boolean
        */
        .then(res => {
          // commit("SET_LIBRARIES_GROUP_COMPONENTS", res.data.data);
          resolve(res);
        })
        .catch(reject);
    });
  },
  addGroupComponents({
    commit
  }, a) {
    return new Promise((resolve, reject) => {
      addLibrariesGroupComponents(a)
        .then(res => {
          commit("ADD_LIBRARY_GROUP_COMPONENTS", res.data.data);
          resolve(res);
        })
        .catch(reject);
    });
  },
  editGroupComponents({
    commit
  }, a) {
    return new Promise((resolve, reject) => {
      editLibrariesGroupComponents(a)
        .then(res => {
          commit("EDIT_LIBRARY_GROUP_COMPONENTS", res.data.data);
          resolve(res);
        })
        .catch(reject);
    });
  },
  deleteGroupComponents({
    commit
  }, a) {
    return new Promise((resolve, reject) => {
      deleteLibrariesGroupComponents(a)
        .then(res => {
          resolve(res);
        })
        .catch(reject);
    });
  },
  editComponentsInGroup({
    commit
  }, a) {
    // изменяю компоненты в группе по ID группы
    return new Promise((resolve, reject) => {
      editComponentsInGroupComponents(a)
        .then(res => {
          // commit("EDIT_LIBRARY_GROUP_COMPONENTS", res.data.data);
          // commit("EDIT_LIBRARY_GROUP_COMPONENTS", res.data.data);
          resolve(res);
        })
        .catch(reject);
    });
  },

  //   // PDK
  fetchPDKComponents({
    commit
  }, a) {
    return new Promise((resolve, reject) => {
      fetchPDKComponentsApi(a)
        .then(res => {
          commit("SET_PDK_COMPONENTS", res.data);
          resolve(res);
        })
        .catch(reject);
    });
  },
  updatePDKComponents({
    commit
  }, a) {
    return new Promise((resolve, reject) => {
      updatePDKComponentsApi(a)
        .then(res => {
          commit("EDIT_PDK_COMPONENTS", res.data);
          resolve(res);
        })
        .catch(reject);
    });
  },
  // KEN
  fetchKENComponents({
    commit
  }, a) {
    return new Promise((resolve, reject) => {
      fetchKENComponentsApi(a)
        .then(res => {
          commit("SET_KEN_COMPONENTS", res.data);
          resolve(res);
        })
        .catch(reject);
    });
  },
  updateKENComponents({
    commit
  }, a) {
    return new Promise((resolve, reject) => {
      updateKENComponentsApi(a)
        .then(res => {
          commit("EDIT_KEN_COMPONENTS", res.data);
          resolve(res);
        })
        .catch(reject);
    });
  }

  // addObject({ commit }, a) {
  //   return new Promise((resolve, reject) => {
  //     addObjectCompany(a)
  //     .then(res => {
  //       resolve(res);
  //     })
  //     .catch(err => {
  //       reject(err);
  //     });
  //   });
  // },
};
